@if (!isPageQuickLink && !isDigiFitMenu()) {
    @if (!isDeactivated) {
        <ng-container>
            @if (quickLink.position.w * quickLink.position.h > 5) {
                <div
                        [class.disabled]="bookFeatureService.pageLinksDisabled"
                        (click)="onClick($event)"
                        [attr.data-combined-link]="quickLink.combinedLink"
                        [attr.data-link]="quickLink.link"
                        class="quick-link">
                </div>
            }
        </ng-container>
    }
    @if (isDeactivated) {
        <ng-container>
            @if (quickLink.position.w * quickLink.position.h > 5) {
                <div
                        [attr.data-bs-placement]="tooltipPosition"
                        class="quick-link"
                        data-bs-html="true"
                        data-bs-toggle="tooltip"
                        title="Dieses Beispiel steht zur<br/> Zeit nicht digital zur Verfügung.">
                </div>
            }
        </ng-container>
    }
}
@if (isDigiFitMenu()) {
    <app-digi-fit-dropdown [page]="page" [quicklink]="quickLink"></app-digi-fit-dropdown>
}

